import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import {
  FaFacebookF,
  FaInstagram,
  FaGoogle,
  FaTiktok,
  IoLogoGooglePlaystore,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import axios from "axios";

function Footer() {
  const useractive = useLocation();
  const [responseData, setResponseData] = useState(null);
  const [EmailData, setEmailData] = useState(null);
  const [PhonenumberData, setPhonenumberData] = useState(null);
  const [address, setAddress] = useState();
  const [error, setError] = useState(null);
  const [activeButton, setActiveButton] = useState(false);
  // const [messages, setMessages] = useState('');
  const [chatbootdata, setChatBootData] = useState([]);
  const [Messagestyper, setMessagestyper] = useState([]);
  const [inputmessage, setinputmessage] = useState("");

  const [messages, setMessages] = useState([]);
  const inputRef = useRef(null);
  const messagesContainerRef = useRef(null);

  const appendMessage = async (message, sender) => {
    const newMessage = {
      text: message,
      sender: sender,
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  };

  const handleSend = async () => {
    const userMessage = inputRef.current.value.trim();

    // setinputmessage(userMessage);
    if (!userMessage) return;
    appendMessage(userMessage, "user");
    inputRef.current.value = "";

    try {
      console.log("mmmmmm", messages);
      // const messageData =  inputmessage;
      // const formData = new FormData();
      // formData.append("message", messageData);
      const messageData = inputmessage;
      const response = await axios.post("chatboat", { message: userMessage });
      // Replace with your actual endpoint
      console.log("responce----->chatboat", response.data.success);

      // const data = await response.json();

      if (response.data.success === true) {
        // const botMessage = data.data || "No response from the AI.";
        appendMessage(response.data.data, "bot");
      } else {
        appendMessage("Error: Unable to fetch response.", "bot");
      }
    } catch (error) {
      console.log("hello", error);
      appendMessage("Error: Network issue or server is unavailable.", "bot");
    }
  };

  const handleSendMessage = (message) => {
    setMessagestyper((prevMessages) => [...prevMessages, message]);
    console.log("Message sent:", message);

    // Simulate a bot reply after a short delay
    setTimeout(async () => {
      const formData = new FormData();
      formData.append("message", message);
      const response = await axios.post("chatboat", formData);
      // Replace with your actual endpoint
      console.log("responce----->chatboat", response.data.data);
      const botReply = "This is a simulated reply from the bot."; // Replace with actual logic
      // setMessages((prevMessages) => [...prevMessages, response.data.data]);
      setMessages([response.data.data]);

      //   const botReply = await fetchBotReply(message); // Call the new function to get the reply
      // setMessages((prevMessages) => [...prevMessages, botReply]);
    }, 1000); // 1 second delay
  };

  const fetchBotReply = async (message) => {
    try {
      const response = await axios.post("chatboat", { message });
      // Replace with your actual endpoint
      console.log("responce----->chatboat", response);
      return response.data.reply; // Adjust based on your API response structure
    } catch (error) {
      console.log("Error fetching bot reply:", error);
      return "Sorry, I couldn't get a response."; // Fallback message
    }
  };

  const chatbootfatch = async () => {
    try {
      const response = await axios.post("pages", { page_name: "support" });
      // console.log("========>", response.data);
      setChatBootData(response.data);
    } catch (error) {
      console.log("The error is ==>", error);
      setError(error);
    }
  };

  useEffect(() => {
    const fetchFooterLinks = async () => {
      try {
        const response = await axios.post("pages", { page_name: "support" });
        console.log("fffff========>", response.data);
        setResponseData(response.data);
        setEmailData(response.data.email.page_description);
        setAddress(response.data.address.page_description);
        setPhonenumberData(response.data.phone_number.page_description);
      } catch (error) {
        console.log("The error is ==>", error);
        setError(error);
      }
    };
    fetchFooterLinks();
  }, []);

  return (
    <>
      <div className="chat-bar-collapsible chatboatforpredefinenew resposive-width-add">
        {/* <button
          id="chat-button"
          type="button"
          className="collapsible"
          onClick={() => setActiveButton((value) => !value)}
          style={{ backgroundColor: "#ffcc00", color: "#1f1f1f" }}
        >
          Chat with us!
          <i
            id="chat-icon"
            style={{ color: "#1f1f1f" }}
            className="fa fa-fw fa-comments-o"
          ></i>
        </button> */}

        <div
          className="content"
          style={{ maxHeight: activeButton ? "500px" : "" }}
        >
          <div className="full-chat-block">
            <div className="outer-container">
              <div className="chat-container">
                <div id="chatbox">
                  <h5 id="chat-timestamp"></h5>
                  <div
                    id="chatbotMessages"
                    ref={messagesContainerRef}
                    className="userText"
                    // style={{
                    //   flexGrow: 1,
                    //   overflowY: "auto",
                    //   padding: "10px",
                    //   backgroundColor: "#f9f9f9",
                    // }}
                  >
                    {messages.map((msg, index) => (
                      <div
                        key={index}
                        className="botText"
                        // style={{
                        //   marginBottom: "10px",
                        //   padding: "10px",
                        //   borderRadius: "5px",
                        //   background:
                        //     msg.sender === "user"
                        //       ? "rgb(243 240 160)"
                        //       : "rgb(241 247 233)",
                        //   alignSelf:
                        //     msg.sender === "user" ? "flex-end" : "flex-start",
                        //   maxWidth: "103%",
                        //   alignSelf:
                        //     msg.sender === "user" ? "flex-end" : "flex-start",
                        // }}
                      >
                        <p
                          className={`${
                            msg.sender === "user" ? "botText" : "userText"
                          }`}
                        >
                          <span style={{ textAlign: "center" }}>
                            {msg.text ? msg.text : "Welcome to our website"}
                          </span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* <div id="chatbox">
                  <h5 id="chat-timestamp"></h5>
                  <p
                    id="botStarterMessage"
                    ref={messagesContainerRef}
                    className="botText"
                  >
                    <span>Loading.....</span>
                  </p>
                  {messages.map((msg, index) => (
                    <>
                      <p className="userText">
                        <span>{msg.text}</span>
                      </p>
                    </>
                  ))}
                </div> */}

                <div className="chat-bar-input-block">
                  {/* <div
                    style={{
                      display: "flex",
                      padding: "10px",
                      borderTop: "1px solid #ccc",
                    }}
                  > */}
                  <input
                    type="text"
                    id="chatbotInput"
                    ref={inputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSend();
                    }}
                    // style={{
                    //   flexGrow: 1,
                    //   padding: "10px",
                    //   borderRadius: "5px",
                    //   border: "1px solid #ccc",
                    // }}
                    className="input-box"
                    placeholder="Type your message here..."
                  />

                  <div className="chat-bar-icons">
                    <i
                      id="chat-icon"
                      style={{ color: "#333" }}
                      className="fa fa-fw fa-send"
                      onClick={handleSend}
                    ></i>
                  </div>
                  {/* </div> */}
                </div>

                <div id="chat-bar-bottom">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="block-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 col-ms-6">
              <h4>About Us</h4>
              {/* <TypeAnimation
                sequence={[
                 
                  " ",
                  1000, // wait 1s before replacing "Mice" with "Hamsters"
                  "Parqd is your all-in-one solution for all types of parking and vehicle storage. Our comprehensive platform offers a wide range  of services tailored to meet the diverse parking and storage   requirements of our customers.",
                  1000,
                ]}
                wrapper="p"
                speed={10}
                // style={{ fontSize: "2em", display: "inline-block" }}
                repeat='0'
                cursor='true'
              /> */}
              <p style={{ alignItems: "center" }}>
                Parqd is your all-in-one solution for all types of parking and
                vehicle storage. Our comprehensive platform offers a wide range
                of services tailored to meet the diverse parking and storage
                requirements of our customers.{" "}
              </p>

              <div className="social-small social-yellow">
                {/* <a href="#" className="fa fa-facebook-square"></a> */}

                <a href="https://www.facebook.com/parqdusa" target="_blank">
                  <FaFacebookF
                    style={{
                      width: "20px",
                      height: "23px",
                      marginBottom: "8px",
                      color: "#ffcc00",
                    }}
                  />
                </a>
                <a href="https://www.instagram.com/getparqd/" target="_blank">
                  <FaInstagram
                    style={{ width: "20px", height: "40px", color: "#ffcc00" }}
                  />
                </a>
                {/* <a href="https://google.com/" target="_blank">
                  <FaGoogle
                    style={{ width: "20px", height: "40px", color: "yellow" }}
                  />
                </a> */}
                <a href="https://x.com/getparqd" target="_blank">
                  <FaXTwitter
                    style={{ width: "20px", height: "40px", color: "yellow" }}
                  />
                </a>
                <a href="https://www.tiktok.com/@parqd" target="_blank">
                  <FaTiktok
                    style={{ width: "20px", height: "40px", color: "yellow" }}
                  />
                </a>
                <div className="social-small social-yellow">
                  <h4>Also Avaiable on</h4>

                  <a
                    href="https://play.google.com/store/apps/details?id=com.parqd.carparking.parkingapplication"
                    target="_blank"
                    style={{ marginRight: "25px" }}
                  >
                    <img
                      src="/images/google-play.png"
                      style={{ width: "40px", height: "40px" }}
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/in/app/parqd/id6450701850"
                    target="_blank"
                  >
                    <img
                      src="/images/app-store.png"
                      style={{ width: "40px", height: "40px" }}
                    />
                  </a>
                </div>
                {/* <a href="#" className="fa fa-instagram"></a>
                <a href="#" className="fa fa-google-plus"></a>
                <a href="#" className="fa fa-twitter"></a> */}
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <h4>Explore</h4>
              <div className="row rowforexplorefootermenu">
                <div className="col-md-5">
                  <ul className="nav navbar-nav">
                    {/* <li>
                      <Link to="/">Find Storage</Link>
                    </li> */}
                    <li>
                      <Link
                        to="aboutus"
                        className={
                          useractive.pathname == "/about" ? "userActive" : ""
                        }
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/parking">Spacings</Link>
                    </li>
                    {/* <li>
                      <Link to="/work">How It Works</Link>
                    </li> */}
                    <li>
                      <Link to="/faq">FAQ</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-5">
                  <ul className="nav navbar-nav">
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/privacy"> Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/terms-and-condition">Terms & Conditions</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-ms-6">
              <h4>Contact Us</h4>
              <p>
                <span className="yellow">Address:</span>
                {address
                  ? address
                  : "Parqd LLC, 9005 Overlook Blvd, Brentwood, TN 37027"}
                {/* Parqd LLC, 9005
                Overlook Blvd, Brentwood, TN 37027 */}
                {/* 43 2-nd Avenue, New York, NY 29004-7153 */}
              </p>
              <ul className="address">
                {/* <li>
                  {responseData ? (
                    <div>
                      <span className="fa fa-phone" style={{transform: "rotateY(180deg)"}}></span>
                      {responseData["phone_number"]["page_description"]}
                    </div>
                  ) : (
                    <div>Loading...</div>
                  )}
                </li>

                <li>
                  {responseData ? (
                    <div>
                      <span className="fa fa-envelope"></span>
                      <a href=""></a>
                      {responseData["email"]["page_description"]}
                    </div>
                  ) : (
                    <div>Loading...</div>
                  )}
                 

                </li> */}

                <li>
                  <span className="fa fa-envelope"></span>
                  <a href={`mailto:${EmailData}`}>{EmailData}</a>
                </li>
                <li>
                  <span
                    className="fa fa-phone"
                    // style={{ transform: "rotateY(180deg)" }}
                  ></span>{" "}
                  <a href={`tel:${PhonenumberData}`}>{PhonenumberData}</a>{" "}
                </li>
              </ul>
            </div>
            {/* <VerticalAlignTopIcon  sx={{ fontSize: 40 }} /> */}
            <i
              className="fa-solid fa-arrow-up  topbuttonicon"
              onClick={() => window.scrollTo(0, 0)}
            ></i>
          </div>
        </div>
      </section>

      <footer>
        <div className="container contforfootercopyright">
          ©<a href="#!">Parqd</a> 2025. All Rights Reserved Designed by
          <a href="https://www.webmobril.com/"> Webmobril</a>
        </div>
      </footer>
    </>
  );
}

export default Footer;
